import { Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BrandMarkProps {
  showTitle?: boolean;
  title?: string;
  className?: string;
  iconClassName?: string;
}

const BrandMark = ({
  showTitle = true,
  title = 'AI Assistant',
  className,
  iconClassName,
}: BrandMarkProps) => (
  <div className={cn('flex items-center gap-3', className)}>
    <div
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 text-primary',
        iconClassName
      )}
    >
      <Bot className="h-5 w-5" aria-hidden="true" />
    </div>
    {showTitle ? <span className="text-xl font-semibold tracking-tight">{title}</span> : null}
  </div>
);

export default BrandMark;
